module.exports = __webpack_public_path__ + "img/jicheng (2).5499d0e2.png";